import { Button } from "@/components/ui/button";

const IntroScreen = ({ intro, onNext, onBack }) => {
  return (
    <div className="min-h-screen flex items-center justify-center pb-8 sm:pb-12 px-4 slide-up" style={{ paddingTop: '110px' }}>
      <div className="max-w-2xl w-full space-y-6 sm:space-y-8 md:space-y-10">
        <div className="space-y-4 sm:space-y-5">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[hsl(var(--text-primary))] leading-tight" style={{ letterSpacing: '-0.02em' }}>
            {intro.title}
          </h2>
          
          <p className="text-base sm:text-lg md:text-xl text-[hsl(var(--text-primary))] leading-relaxed" style={{ letterSpacing: '-0.01em' }}>
            {intro.description}
          </p>

          {intro.microcopy && (
            <p className="text-sm sm:text-base text-[hsl(var(--text-secondary))] italic leading-relaxed" style={{ letterSpacing: '-0.01em' }}>
              {intro.microcopy}
            </p>
          )}
        </div>

        <div className="pt-4">
          <div className="flex items-center gap-4">
            {/* Botón Atrás */}
            {onBack && (
              <Button
                onClick={onBack}
                variant="secondary"
                size="lg"
                className="h-14 px-6 text-base font-semibold"
              >
                Atrás
              </Button>
            )}
            
            {/* Botón Continuar */}
            <Button
              onClick={onNext}
              size="lg"
              className="flex-1 h-14 text-base font-semibold"
            >
              Continuar
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IntroScreen;
